const LOCK_COUNT_KEY = '__ZD_SCROLL_LOCK_COUNT__'
const PADDING_KEY = '__ZD_SCROLL_LOCK_PADDING__'
const GAP_PROPERTY = '--scroll-lock-gap'

function getLockCount() {
  const count = window[LOCK_COUNT_KEY]
  return typeof count === 'number' && count > 0 ? count : 0
}

function compensateScrollbar() {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
  if (scrollbarWidth <= 0) return

  const { body } = document
  const paddingRight = parseFloat(window.getComputedStyle(body).paddingRight) || 0
  window[PADDING_KEY] = body.style.paddingRight
  body.style.paddingRight = `${paddingRight + scrollbarWidth}px`
  document.documentElement.style.setProperty(GAP_PROPERTY, `${scrollbarWidth}px`)
}

function restoreScrollbar() {
  const previous = window[PADDING_KEY]
  if (typeof previous !== 'string') return

  document.body.style.paddingRight = previous
  document.documentElement.style.removeProperty(GAP_PROPERTY)
  delete window[PADDING_KEY]
}

export function lockScroll() {
  const next = getLockCount() + 1
  window[LOCK_COUNT_KEY] = next
  if (next === 1) {
    compensateScrollbar()
    document.body.classList.add('overflow-hidden')
  }
}

export function unlockScroll() {
  const next = Math.max(0, getLockCount() - 1)
  window[LOCK_COUNT_KEY] = next
  if (next === 0) {
    document.body.classList.remove('overflow-hidden')
    restoreScrollbar()
  }
}
